module.exports = new __parcel__URL__("insight-object-timeline-skeleton.tpl.f3773a50.svg").toString();